// extracted by mini-css-extract-plugin
export default {"tab":"aQEAZ_nja96Wr4GPAWO5"};